module.exports = __webpack_public_path__ + "static/media/chartjs.45729bde.svg";